"use client";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@repo/ui/components/ui/dropdown-menu";
import { IconUserCircle } from "@tabler/icons-react";
import { useTranslations } from "next-intl";
import { buttonVariants } from "@/components/ui/button";
import { AuthDivider } from "@/features/auth/components/elements/auth-divider";
import {
  AUTH_PRIMARY_BUTTON,
  AUTH_SECONDARY_BUTTON,
} from "@/features/auth/lib/auth-button-styles";
import { Link } from "@/i18n/navigation";
import { cn } from "@/lib/utils";

/**
 * The header sends users to the dedicated auth pages; the modal is reserved for
 * entry points that must keep the user in place (cart, checkout, order status).
 */
export const SignInMenu = () => {
  const t = useTranslations("header");

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="flex h-12 items-center gap-2 rounded-xl px-5 py-3 text-current"
        data-pw="sign-in-menu-button"
      >
        <IconUserCircle className="size-6 shrink-0" stroke={1.5} />
        <span className="font-medium text-base">{t("signIn")}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="flex w-80 flex-col gap-2 rounded-xl border-border p-4 shadow-[0_2px_3px_0_rgba(0,0,0,0.08)]"
        data-pw="sign-in-menu"
        sideOffset={12}
      >
        <Link
          className={cn(buttonVariants({ variant: "ghost" }), AUTH_PRIMARY_BUTTON)}
          data-pw="sign-in-button"
          href={{ pathname: "/sign-in/[[...sign-in]]", params: { "sign-in": [] } }}
        >
          {t("signIn")}
        </Link>
        <AuthDivider label={t("noAccount")} />
        <Link
          className={cn(
            buttonVariants({ variant: "ghost" }),
            AUTH_SECONDARY_BUTTON
          )}
          data-pw="sign-up-button"
          href={{ pathname: "/sign-up/[[...sign-up]]", params: { "sign-up": [] } }}
        >
          {t("signUp")}
        </Link>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
